export const b2bSepaTranslations = {
  direct_debit_mandate: {
    get_data: {
      error: 'Failed to get data: %{error}',
    },
    sign: {
      error: 'Failed to sign the mandate: %{error}',
    },
  },
};
